exports.default = {
  'recent_use': 'Recent',
  'search': 'Search Agents',
  'search_not_found': 'No results for {value}',
  'more_result': 'More results about {value} search >'
}
